module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cc4f8c9c6365f454f917f76d4852617b.png";